var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGenieSmart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 148,
    height: 22,
    viewBox: "0 0 148 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_387",
    "data-name": "Rectangle 387",
    width: 118.559,
    height: 15.261,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-GenieSmart"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 22
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GenieSmart",
    clipPath: "url(#clip-GenieSmart)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_178700",
    "data-name": "Group 178700",
    transform: "translate(-3577.166 388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_795",
    "data-name": "Group 795",
    transform: "translate(3606.189 -385)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1459",
    "data-name": "Path 1459",
    d: "M136.642,11.723a5.812,5.812,0,0,0,3.755,1.585,2.27,2.27,0,0,0,2.544-2.169c0-3.191-7.133-2.5-7.133-7.029,0-2.295,1.982-4.109,4.756-4.109a5.91,5.91,0,0,1,4.171,1.481l-.938,1.71a5.19,5.19,0,0,0-3.233-1.272,2.408,2.408,0,0,0-2.67,2.148c0,3.045,7.134,2.232,7.134,7.008,0,2.273-1.752,4.151-4.672,4.151a6.888,6.888,0,0,1-4.881-1.94l1.168-1.565Z",
    transform: "translate(-74.185 0)",
    fill: "#ea9a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1460",
    "data-name": "Path 1460",
    d: "M163.364,9.471h1.961v1.4a7.412,7.412,0,0,1-.042.772h.042a4.125,4.125,0,0,1,3.629-2.42,2.88,2.88,0,0,1,3.17,2.4h.042a4.251,4.251,0,0,1,3.755-2.4c2.378,0,3.484,1.356,3.484,4.046v6.758H177.38V13.7c0-1.481-.292-2.649-1.877-2.649a3.288,3.288,0,0,0-2.962,2.691,6.309,6.309,0,0,0-.146,1.46v4.818h-2.023V13.7c0-1.377-.208-2.649-1.835-2.649s-2.628,1.273-3.024,2.774a5.823,5.823,0,0,0-.125,1.377v4.818h-2.023V9.471Z",
    transform: "translate(-89.457 -5.049)",
    fill: "#ea9a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1461",
    "data-name": "Path 1461",
    d: "M211.124,13.435h.459v-.188a2.051,2.051,0,0,0-2.315-2.315,5.349,5.349,0,0,0-2.941,1.022l-.834-1.481a6.618,6.618,0,0,1,3.942-1.252c2.67,0,4.172,1.46,4.172,4.13v6.675h-1.877v-1a7.934,7.934,0,0,1,.042-.834h-.042a3.651,3.651,0,0,1-3.379,2.086,3.3,3.3,0,0,1-3.588-3.212C204.762,13.581,209.351,13.435,211.124,13.435Zm-2.336,5.214c1.711,0,2.815-1.793,2.815-3.358v-.333h-.521c-1.523,0-4.276.1-4.276,2a1.768,1.768,0,0,0,1.982,1.689Z",
    transform: "translate(-112.127 -5.049)",
    fill: "#ea9a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1462",
    "data-name": "Path 1462",
    d: "M232.145,9.623h1.961v1.835a7.588,7.588,0,0,1-.042.793h.042a3.389,3.389,0,0,1,3.859-2.712v2a2.919,2.919,0,0,0-.584-.062,3.2,3.2,0,0,0-2.962,2.482,6.411,6.411,0,0,0-.251,1.9v4.318h-2.023Z",
    transform: "translate(-127.122 -5.201)",
    fill: "#ea9a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1463",
    "data-name": "Path 1463",
    d: "M249.888,8.04h-1.377V6.413h1.439V3.368h1.961V6.413h2.544V8.04h-2.544v4.693a2.1,2.1,0,0,0,2.252,2.377,2.46,2.46,0,0,0,.48-.041v1.794a5.561,5.561,0,0,1-.709.042c-1.355,0-4.046-.417-4.046-3.942Z",
    transform: "translate(-136.084 -1.844)",
    fill: "#ea9a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    "data-name": "Path 1464",
    d: "M43.428,9.324c3.039,0,4.672,2.212,4.672,5,0,.309-.062,1.013-.062,1.013H40.762a3,3,0,0,0,3.163,2.79,5.208,5.208,0,0,0,3.038-1.158l1.013,1.881a6.587,6.587,0,0,1-4.237,1.509,5.4,5.4,0,0,1-5.663-5.519A5.211,5.211,0,0,1,43.43,9.325Zm2.026,4.217a2.035,2.035,0,0,0-2.088-2.191,2.455,2.455,0,0,0-2.522,2.191Z",
    transform: "translate(-20.85 -5.106)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    "data-name": "Path 1465",
    d: "M66.6,9.573h2.522v1.22a6.488,6.488,0,0,1-.042.723h.042a4.089,4.089,0,0,1,3.741-2.191c2.335,0,3.659,1.219,3.659,4.01v6.78h-2.6V13.873c0-1.282-.331-2.15-1.674-2.15a2.965,2.965,0,0,0-2.832,2.15,4.463,4.463,0,0,0-.186,1.406v4.837H66.6V9.573Z",
    transform: "translate(-36.472 -5.107)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1466",
    "data-name": "Path 1466",
    d: "M96.969.2h.3a1.289,1.289,0,0,1,0,2.578h-.3a1.289,1.289,0,0,1,0-2.578M95.8,4.577H98.43V15.118H95.8Z",
    transform: "translate(-52.394 -0.11)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    d: "M113.179,9.324c3.039,0,4.672,2.212,4.672,5,0,.309-.062,1.013-.062,1.013h-7.276a3,3,0,0,0,3.163,2.79,5.208,5.208,0,0,0,3.038-1.158l1.013,1.881a6.587,6.587,0,0,1-4.237,1.509,5.4,5.4,0,0,1-5.663-5.519,5.21,5.21,0,0,1,5.354-5.518Zm2.026,4.217a2.035,2.035,0,0,0-2.088-2.191,2.455,2.455,0,0,0-2.522,2.191Z",
    transform: "translate(-59.046 -5.106)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    d: "M9.82,8.546,7.937,10.429a16.292,16.292,0,0,1,2.935.179,5.933,5.933,0,0,1-2.328,2.008A3.575,3.575,0,0,1,5.9,12.572,4.822,4.822,0,0,1,2.814,8.6a6.94,6.94,0,0,1-.079-1.022,5.762,5.762,0,0,1,.166-1.3.041.041,0,0,1,0-.009A4.588,4.588,0,0,1,7.3,2.643a6.668,6.668,0,0,1,4.829,1.792l1.658-1.658A8.073,8.073,0,0,0,7.318.2H7.3A7.319,7.319,0,0,0,.143,6.259l0,.011A7.766,7.766,0,0,0,0,7.658,9,9,0,0,0,.057,8.665h0a7.151,7.151,0,0,0,7.224,6.7c1.116.062,3.328-.433,5.272-2.973a16.039,16.039,0,0,1,.179,2.869V15.3l1.888-1.9V8.545H9.82Z",
    transform: "translate(0 -0.11)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_App_GBS_GenieSmart_Icon",
    "data-name": "[App] GBS GenieSmart Icon",
    transform: "translate(3577.166 -388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GB_GenieSmart_Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M34.39,22.022l-1.574-1.574-5.482,5.483-2.025-2.024-1.574,1.574,2.024,2.024h0l1.575,1.574,1.574-1.574h0Z",
    transform: "translate(-13.366 -11.5)",
    fill: "#f7941e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(3.284 5.385)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M20.709,15.486H11.454a.812.812,0,0,1,0-1.623h9.252a.812.812,0,1,1,0,1.623Z",
    transform: "translate(-10.642 -13.863)",
    fill: "#f7941e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(0 4.698)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M17.626,24.168H11.454a.812.812,0,0,1,0-1.623h6.172a.812.812,0,1,1,0,1.623Z",
    transform: "translate(-10.642 -22.545)",
    fill: "#f7941e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(0 9.396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M15.874,32.851h-4.42a.812.812,0,0,1,0-1.623h4.42a.812.812,0,0,1,0,1.623Z",
    transform: "translate(-10.642 -31.228)",
    fill: "#f7941e"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M20.364,21.956v1.26a.812.812,0,0,1-.812.812H7.007a.812.812,0,0,1-.812-.812V6.345a.812.812,0,0,1,.812-.812H19.552a.812.812,0,0,1,.812.812v7.915l1.623-1.623V6.345A2.437,2.437,0,0,0,19.552,3.91H7.007A2.437,2.437,0,0,0,4.572,6.345v16.87A2.437,2.437,0,0,0,7.007,25.65H19.552a2.437,2.437,0,0,0,2.435-2.435V20.332Z",
    transform: "translate(-4.572 -3.91)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenieSmart);
export default __webpack_public_path__ + "static/media/GenieSmart.532caa80a11b144ada6d6a3148a4a117.svg";
export { ForwardRef as ReactComponent };